import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of as observableOf } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ReadingListService } from '®shared/reading-list/models';

import {
  DraftReadingListLoadedAction,
  DraftReadingListLoadingFailedAction,
  DraftReadingListRequestedAction,
  ListResolverStoreActionTypes,
  PublishedReadingListLoadedAction,
  PublishedReadingListLoadingFailedAction,
  PublishedReadingListRequestedAction,
} from './list-resolver-store.actions';

@Injectable()
export class ListResolverStoreEffects {
  constructor(
    private actions$: Actions,
    private readingListService: ReadingListService,
  ) {}

  fetchDraftReadingList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ListResolverStoreActionTypes.LIST_RESOLVER_STORE_DRAFT_REQUESTED),
      switchMap((action: DraftReadingListRequestedAction) => {
        const { listId } = action.payload;
        return this.readingListService.getReadingListDetails(listId, true).pipe(
          map(
            list =>
              new DraftReadingListLoadedAction({
                listId,
                list,
              }),
          ),
          catchError(error =>
            observableOf(
              new DraftReadingListLoadingFailedAction({
                listId,
                error,
              }),
            ),
          ),
        );
      }),
    ),
  );

  fetchPublishedReadingList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        ListResolverStoreActionTypes.LIST_RESOLVER_STORE_PUBLISHED_REQUESTED,
      ),
      switchMap((action: PublishedReadingListRequestedAction) => {
        const { listId } = action.payload;
        return this.readingListService
          .getReadingListDetails(listId, false)
          .pipe(
            map(
              list =>
                new PublishedReadingListLoadedAction({
                  listId,
                  list,
                }),
            ),
            catchError(error =>
              observableOf(
                new PublishedReadingListLoadingFailedAction({
                  listId,
                  error,
                }),
              ),
            ),
          );
      }),
    ),
  );
}
